import { useTemplateContext } from '../../../context';
import { SMSPrimaryContent } from '../../../types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText } from '../Sections.styled';

export const SMSSendingInformationSection = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;
  const sender = (primaryContent as SMSPrimaryContent)?.smsSender?.name;

  return (
    <CampaignFormField labelText="Sender">
      <ReadOnlyField name="sender">{sender || <LightText>Not set</LightText>}</ReadOnlyField>
    </CampaignFormField>
  );
};
